import { useHead } from 'unhead';
import { useRoute } from 'vue-router';
import { getHeadTitle } from '@/utils/pageUtils';

export function usePageTitle() {
    const route = useRoute();

    useHead({
        title: getHeadTitle(route.meta.title)
    });
}